module.exports = __webpack_public_path__ + "img/cala-game-color.e02bd471.png";